<!-- <section class="section white-100" *ngIf="termData">
  <div class="section-container-inside">
    <div class="section-heading mar-b-48 padd-t-96">{{ termData.title }}</div>
    <iframe [src]="fileUrl" class="pdf-container margin-top-2rem"> </iframe>
  </div>
</section> -->


<div class="top-section terms-conditions-section">
  <section class="section-white">
    <div class="section-container-inside">
      <div class="section-heading mar-b-48 padd-t-96">
        {{ termData?.title }}
      </div>
      <div class="content-wrapper">
        <div class="side_bar">
          <h3 class="cs_h6 side_bar_title">
            {{ termData?.sidePanelTitle }}
          </h3>
          <div class="tabbing_linls_warpper">
            <ul class="nav-tab pt-2 nav">
              <li
                *ngFor="let item of termData?.sidePanelLinks; let i = index"
                [ngClass]="{ 'nav-item active': selectedItem === i }"
                (click)="selectedItem = i"
              >
                <a class="nav-link active" (click)="onClick(i)">{{
                  item.fields.title
                }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="content-detail">
          <article class="content_wrapper spt">
            <div
              class="wys ul_listing p-md mb-3"
              id="target{{ i + 1 }}"
              [innerHtml]="text?.fields?.panelTextContent | toHtml"
              *ngFor="let text of termData?.textPanels; let i = index"
            ></div>
          </article>
        </div>
      </div>
    </div>
  </section>
</div>
